import { ApiResponse } from '@nf/types/api';
import { ApiBackendInfo } from './types';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { useApiBackendInfo } from '../use-api-backend-info';
import { useQuery } from '@tanstack/react-query';
import queryKeys from '@/constants/query-keys';
import { siteService } from '@/services/site.service';
import { LicenseeTypeEnums } from '@nf/types/site';

export enum ContactInfoTypeEnum {
	LiveChat = 0,
	Skype = 1,
	QQ = 2,
	WhatsApp = 3,
	Line = 4,
	LineNoLink = 5,
	WeChat = 6,
	Facebook = 7,
	Twitter = 8,
	Instagram = 9,
	Yahoo = 10,
	BBIM = 11,
	TollFree = 12,
	Address = 13,
	Telegram = 14,
	Zalo = 15,
	Viber = 16,
	SMS = 17,
	Kakaotalk = 18,
	Webo = 19,
	Others = 20,
	Tel = 21,
	Email = 22,
	PengaduanCS = 23
}

export interface ContactInfoTypeSetting {
	title: string;
	link: string;
}

export interface ContactInfoSetting {
	Type: ContactInfoTypeEnum;
	Data: ContactInfoTypeSetting[];
}

export interface ContactInfoRawSetting {
	Type: ContactInfoTypeEnum;
	Data: string;
}

export interface AthenaCustomSetting {
	PromotionUrl: string | undefined;
	LiveChatUrl: string | undefined;
	LiveChatWidgetScript: string | undefined;
	ContactInfo: ContactInfoRawSetting[] | undefined;
}

const mockAthenaCustomSetting: ApiResponse<AthenaCustomSetting> = {
	Data: {
		PromotionUrl: 'https://www.aonplus.com/admin/images/footer/promotion.php',
		LiveChatUrl: 'https://direct.lc.chat/1600431/',
		LiveChatWidgetScript: 'window.__lc = window.__lc || {};window.__lc.license = 1600431;(function(){var lc = document.createElement(\'script\'); lc.type = \'text/javascript\'; lc.async = true; lc.src = (\'https:\' == document.location.protocol ? \'https://\' : \'http://\') + \'cdn.livechatinc.com/tracking.js\'; var s = document.getElementsByTagName(\'script\')[0]; s.parentNode.insertBefore(lc, s);})();',
		ContactInfo: [
			{
				'Type': 1,
				'Data': '[{\"title\":\"cs.itcbet\",\"link\":\"\"}]'
			},
			{
				'Type': 2,
				'Data': '[{\"title\":\"Test QQ\",\"link\":\"\"}]'
			},
			{
				'Type': 3,
				'Data': '[{\"title\":\"+6287745573434\",\"link\":\"whatsapp://send?abid=+6287745573434&text=Hello\"},{\"title\":\"+6285931998030\",\"link\":\"whatsapp://send?abid=+6285931998030&text=Hello\"}]'
			},
			{
				'Type': 4,
				'Data': '[{\"title\":\"Test Line\",\"link\":\"\"}]'
			},
			{
				'Type': 5,
				'Data': '[{\"title\":\"aoncash.id\",\"link\":\"\"}]'
			},
			{
				'Type': 6,
				'Data': '[{\"title\":\"axioobet\",\"link\":\"\"}]'
			},
			{
				'Type': 7,
				'Data': '[{\"title\":\"Test Facebook\",\"link\":\"\"}]'
			},
			{
				'Type': 8,
				'Data': '[{\"title\":\"BE7com\",\"link\":\"\"}]'
			},
			{
				'Type': 9,
				'Data': '[{\"title\":\"\",\"link\":\"https://www.instagram.com/bolaligasatu\"}]'
			},
			{
				'Type': 10,
				'Data': '[{\"title\":\"cs1.axioobet@yahoo.com\",\"link\":\"\"},{\"title\":\"cs2.axioobet@yahoo.com\",\"link\":\"\"}]'
			},
			{
				'Type': 11,
				'Data': '[{\"title\":\"BOLANA\",\"link\":\"\"}]'
			},
			{
				'Type': 12,
				'Data': '[{\"title\":\"Test TollFree\",\"link\":\"\"}]'
			},
			{
				'Type': 13,
				'Data': '[{\"title\":\"Test Address\",\"link\":\"\"}]'
			},
			{
				'Type': 14,
				'Data': '[{\"title\":\"Test Telegram\",\"link\":\"\"}]'
			},
			{
				'Type': 15,
				'Data': '[{\"title\":\"Test Zalo\",\"link\":\"\"}]'
			},
			{
				'Type': 16,
				'Data': '[{\"title\":\"Test Viber\",\"link\":\"\"}]'
			},
			{
				'Type': 17,
				'Data': '[{\"title\":\"+6281319837837\",\"link\":\"\"}]'
			},
			{
				'Type': 18,
				'Data': '[{\"title\":\"BE7com\",\"link\":\"\"}]'
			},
			{
				'Type': 19,
				'Data': '[{\"title\":\"Test Webo\",\"link\":\"\"}]'
			},
			{
				'Type': 20,
				'Data': '[{\"title\":\"\",\"link\":\"http://www.bolanation.net\"}]'
			},
			{
				'Type': 21,
				'Data': '[{\"title\":\"\",\"link\":\"+6282118119119\"},{\"title\":\"\",\"link\":\"+639163688999\"}]'
			},
			{
				'Type': 22,
				'Data': '[{\"title\":\"\",\"link\":\"admin@itcbet.com\"},{\"title\":\"\",\"link\":\"marketing@itcbet.com\"}]'
			},
			{
				'Type': 23,
				'Data': '[{\"title\":\"KLIK DISINI\",\"link\":\"https://www.e-ccf.com/?web=986fb47b51f2ee9920c9025c222bef8bfc98a28c236d3df4ab5b6e3925b68e621be0e6eec6eb61f26fd2f317883eca9ab985727f026234b1c173356d3474a9f8OZXfJC6thWUiY4FTi0vHrVLAyh~XscBvAzwA3SOkCpU-\"}]'
			}
		]
	},
	'ErrorCode': 0,
	'ErrorMsg': ''
}

// export const fetchAthenaCustomSetting = async (apiBackendInfo: ApiBackendInfo): Promise<ApiResponse<AthenaCustomSetting>> => {
// 	return new Promise((resolve) => {
// 		setTimeout(() => {
// 			resolve(mockAthenaCustomSetting);
// 		}, 1000);
// 	});
// };

export const fetchAthenaCustomSetting = async (apiBackendInfo: ApiBackendInfo): Promise<ApiResponse<AthenaCustomSetting>> => {
	const response = await fetchComposer.getWithBearer(`${apiBackendInfo.url}/Athena/GetAthenaCustomSetting`)(apiBackendInfo.token);
	if (!response.ok) {
		throw new Error(`${response.status}: ${response.statusText}`);
	}
	return await response.json();
};

export const useAthenaCustomSetting = () => {
	const isAthena = siteService.getLicenseeType() === LicenseeTypeEnums.Athena;
	const apiBackendInfo = useApiBackendInfo();
	const { data, isLoading, isError, error, refetch } = useQuery({
		queryKey: [queryKeys.ATHENA_CUSTOM_SETTING, apiBackendInfo.url, apiBackendInfo.token],
		queryFn: () => fetchAthenaCustomSetting(apiBackendInfo),
		refetchOnWindowFocus: false,
		staleTime: 1000 * 30,
		cacheTime: 1000 * 60,
		enabled: isAthena && apiBackendInfo.isReady
	});

	return {
		data: data?.Data,
		isLoading,
		isError,
		error,
		refetch
	};
};